import React from 'react';

function RefundPolicy() {
  return (
    <div class="container py-5 my-md-5">
      <h1>Refund Policy</h1>
      <p>Thank you for registering in a program with us. We want to make sure that our customers have an exceptional learning experience online. As with any online purchase experience, the below are the terms and conditions that govern the Refund Policy. When you buy a program on the <a href="https://www.nxg.co.in">www.nxg.co.in</a> you agree to our Privacy Policy, Terms of Use and the conditions covered below.</p>

      <h2 class="section-title">Cancellation & Refunds: Online Training</h2>
      <p>We understand that you can change your mind. We know that some of our programs might not be 100% relevant to you in your current need or you might not be able to attend the program session on the scheduled date. With sincere apologies, we would like to inform you that we won't be able to provide you a refund on your cancellation. However, we assure you that you can join our forthcoming program for free.</p>

      <h2 class="section-title">Refunds: Duplicate payment</h2>
      <p>Refund of the duplicate payment made by the customer will be processed via the same source (original method of payment) within 7 to 21 working days after intimation by the customer.</p>

      <p><strong>Note:</strong> All refunds will be processed within 30 days of approval and validation of the refund request.</p>
    </div>
  );
}

export default RefundPolicy;